import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface PhoneNumberInfo {
  display: string;
  tel: string;
}

const PHONE_NUMBERS = {
  'Suffolk': { display: '(631) 710-7600', tel: '+16317107600' },
  'Nassau': { display: '(516) 726-9555', tel: '+15167269555' },
  default: { display: '(631) 710-7600', tel: '+16317107600' }
};

export const usePhoneNumber = (cityName?: string): PhoneNumberInfo => {
  const [phoneInfo, setPhoneInfo] = useState<PhoneNumberInfo>(PHONE_NUMBERS.default);

  useEffect(() => {
    const fetchPhoneNumber = async () => {
      if (!cityName || cityName === "Long Island") {
        setPhoneInfo(PHONE_NUMBERS.default);
        return;
      }

      try {
        console.log('Looking up phone number for city:', cityName);
        
        // Try primary city first
        let { data, error } = await supabase
          .from('city_groups')
          .select('county')
          .ilike('primary_city', `%${cityName}%`)
          .limit(1)
          .maybeSingle();

        // If not found in primary city, check display_cities array
        if (!data && !error) {
          ({ data, error } = await supabase
            .from('city_groups')
            .select('county')
            .contains('display_cities', [cityName])
            .limit(1)
            .maybeSingle());
        }

        console.log('Query result:', { data, error });

        if (error) {
          console.error('Error fetching county for phone number:', error);
          setPhoneInfo(PHONE_NUMBERS.default);
        } else if (data?.county && PHONE_NUMBERS[data.county as keyof typeof PHONE_NUMBERS]) {
          console.log('Found county:', data.county, 'Setting phone number to:', PHONE_NUMBERS[data.county as keyof typeof PHONE_NUMBERS]);
          setPhoneInfo(PHONE_NUMBERS[data.county as keyof typeof PHONE_NUMBERS]);
        } else {
          console.log('No county found or no phone number for county, using default');
          setPhoneInfo(PHONE_NUMBERS.default);
        }
      } catch (error) {
        console.error('Error fetching county for phone number:', error);
        setPhoneInfo(PHONE_NUMBERS.default);
      }
    };

    fetchPhoneNumber();
  }, [cityName]);

  return phoneInfo;
};